import { render } from "./MerchantCustomerDetails.vue?vue&type=template&id=a4c3010c"
import script from "./MerchantCustomerDetails.vue?vue&type=script&lang=js"
export * from "./MerchantCustomerDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__